var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid",style:(`grid-row-gap:${_vm.rowGap * 5}px; margin-top: ${_vm.tGap}px; margin-bottom: ${_vm.bGap}px`)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }